var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_vm._v("Tickets")]),_c('div',{staticClass:"panel-box"},[(_vm.support !== null)?_c('div',[_c('SupportDataTable',{attrs:{"entity":_vm.support}})],1):_c('Spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }